<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.push('/cash')"></div>
      <div class="big_tit">{{$t('addbank.addBindAccount')}}</div>
    </div>
    <div class="wrap_box warp1">
      <div class="item">
        <div class="ari_font">{{$t('addbank.accountName')}}：</div>
        <input type="text" v-model="bank.name" :placeholder="$t('Please input your name')">
      </div>
      <!--<div class="item">
        <div class="ari_font">{{$t('addbank.IFSC')}}：</div>
        <input type="text" oninput="value=value.replace(/[ ]/g,'')" v-model="bank.ifsc" :placeholder="$t('addbank.IFSC')">
      </div>-->
      <!-- <div class="item">
        <div class="ari_font">{{$t('addbank.accountBank')}}：</div>
        <select v-model="bank.bank">
          <option value="">{{$t('addbank.selectBank')}}</option>
          <option v-for="(v,k) in banks" :key="k" :value="k">{{ v }}</option>
        </select>
      </div>
      <div class="item">
          <div class="ari_font">省　　份：</div>
          <input type="text" v-model="bank.province" placeholder="请输入省份">
      </div>
      <div class="item">
          <div class="ari_font">城　　市：</div>
          <input type="text" v-model="bank.city" placeholder="请输入城市">
      </div>
      <div class="item">
        <div class="ari_font">{{$t('addbank.bankName')}}：</div>
        <input type="text" v-model="bank.area" :placeholder="$t('addbank.bankName')">
      </div> -->
      <div class="item">
        <div class="ari_font">{{$t('Account No')}}：</div>
        <input type="number" oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')" v-model="bank.card" :placeholder="$t('addbank.insertBankCard')">
      </div>

      <div class="item">
        <div class="ari_font">{{$t('Bank name')}}：</div>
        <div class="choose_bank" @click="showBank = true">
          <span>{{bankName}}</span>
          <van-icon name="arrow" color="#999"/>
        </div>
      </div>
    </div>
    <div class="demo">
      <div class="font-14">{{rule.title}}</div>
      <div class="mt-10" v-html="rule.content"></div>
    </div>
    <div class="basic_btn" @click="submitBtn">{{$t('account.submit')}}</div>
    <div style="height: 30px;"></div>

    <van-action-sheet
            v-model="showBank"
            cancel-text=""
            :description="$t('cash.chooseBank')"
    >
      <div
              v-for="item in bankList"
              :key="item.code"
              class="bank-item"
              @click="onBankSelect(item)"
      >
        <img :src="item.logo" class="bank-logo" />
        <span>{{ item.name }}</span>
      </div>
    </van-action-sheet>

  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'

export default {
  name: "account",
  data() {
    return {
      bank: {
        name: '',
        card: '',
        bank_code: '',
        area: '',
        bank: '',
        ifsc: '',
        // province:'',
        // city:'',
        wid: 7
      },
      showBank: false,
      bankName: '',
      bankCode: '',
      bankList: [
        {code:'ZAR10010',name:'Absa',logo: require('@/assets/images/bank/ABSA Bank.png')},
        {code:'ZAR10011',name:'NedBank',logo: require('@/assets/images/bank/Nedbank.png')},
        // {code:'ZAR10013',name:'Standard'},
        // {code:'ZAR10014',name:'Fnb'},
        {code:'ZAR10015',name:'African Bank',logo: require('@/assets/images/bank/African Bank.png')},
        {code:'ZAR10016',name:'Bidvest Bank',logo: require('@/assets/images/bank/Bidvest Bank.png')},
        {code:'ZAR10017',name:'Discovery',logo: require('@/assets/images/bank/Discovery Bank.png')},
        {code:'ZAR10018',name:'First National Bank',logo: require('@/assets/images/bank/First National Bank.png')},
        {code:'ZAR10019',name:'FirstRand Bank',logo: require('@/assets/images/bank/First Rand Bank.png')},
        // {code:'ZAR10020',name:'Grindrod Bank'},
        {code:'ZAR10021',name:'Imperial Bank',logo: require('@/assets/images/bank/Imperial Bank.png')},
        {code:'ZAR10022',name:'Investec Bank',logo: require('@/assets/images/bank/Investec Bank.png')},
        {code:'ZAR10023',name:'Standard Bank',logo: require('@/assets/images/bank/Standard Bank.png')},
        // {code:'ZAR10025',name:'Ubank'},
        {code:'ZAR10026',name:'TymeBank',logo: require('@/assets/images/bank/TymeBank.png')},
        {code:'ZAR10027',name:'Mercantile Bank',logo: require('@/assets/images/bank/Mercantile Bank.png')},
        {code:'ZAR10028',name:'Albaraka Bank',logo: require('@/assets/images/bank/Albaraka Bank.png')},
        // {code:'ZAR10029',name:'HBZ Bank'},
        {code:'ZAR10030',name:'Habib Overseas Bank',logo: require('@/assets/images/bank/Habib Bank.png')},
        // {code:'ZAR10031',name:'Wesbank'},
        {code:'ZAR10032',name:'Rand Merchant Bank',logo: require('@/assets/images/bank/Rand Merchant Bank.png')},
        // {code:'ZAR10033',name:'Bank of Athens'},
        {code:'ZAR10034',name:'Access Bank',logo: require('@/assets/images/bank/Access Bank.png')},
      ],
      rule: {},
      banks: {
        "BENGKULU": "BANK BENGKULU",
        "EXIMBANK": "BANK EKSPOR INDONESIA",
        "JTRUST": "BANK JTRUST",
        "COMMONWEALTH": "BANK COMMONWEALTH",
        "MERIN": "BANK MERINCORP",
      }
    }
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/rule', { type: 16, }).then(res => {
        this.rule = res.data.rule;
      })
    },
    // 选择银行
    onBankSelect(item){
      this.bankName = item.name
      this.bankCode = item.code
      this.showBank = false
    },
    submitBtn() {
      if (!this.bank.name.replace(/\s/g, "")) {
        this.$notify(this.$t('Please input your name'));
        return;
      }
      if (!this.bank.card.replace(/\s/g, "")) {
        this.$notify(this.$t('addbank.insertBankCard'));
        return;
      }
      if((this.bankCode==null||this.bankCode=='')&&(this.bankName==null||this.bankName=='')){
        this.$notify(this.$t('cash.chooseBank'));
        return false;
      }
      this.bank.bank_code = this.bankCode;
      this.bank.bank = this.bankName;
      Fetch('/user/bank_add', {
        ...this.bank
      }).then(r => {
        this.$toast({
          background: '#07c160',
          message: this.$t('account.success')
        });
        this.$router.push('/account');
      })

    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-dropdown-menu {
  position: relative;
  z-index: 10;
  color: #CCCCCC;
}

/deep/ .van-dropdown-menu__bar {
  position: relative;
  z-index: 10;
  width: 211px;
  height: 34px;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  text-align: left;
}

/deep/ .van-dropdown-item--down {
  width: 211px;
  margin: 0 auto;
  z-index: 12;
  transform: translateX(4px);
}

/deep/ .van-dropdown-menu__item {
  justify-content: flex-start;
  color: #ccc;
  background-color: #fff;
}

/deep/ .van-dropdown-menu__title {
  width: 100%;
}

/deep/ .van-dropdown-menu__title::after {
  width: 13px;
  height: 22px;
  transform: none;
  background: url(../../assets/images/drop.png) no-repeat center center;
  background-size: 100% 100%;
  border: none;
  opacity: 1;
  margin-top: -11px;
  right: 10px;
}

/deep/ .van-cell {
  padding: 5px 8px;
}

/deep/ .van-cell__title {
  flex: 3;
  white-space: normal;
}

/deep/ .van-ellipsis {
  color: #000;
}

/deep/ .van-dropdown-item__option {
  color: #ccc;
  border: 1px solid #D9D9D9;
  border-bottom: none;
  border-radius: 4px;
}

/deep/ .van-dropdown-item__option:last-child {
  border-bottom: 1px solid #D9D9D9;
}

/deep/ .van-dropdown-item__option--active.van-dropdown-item__option {
  color: #000;

  .van-dropdown-item__icon {
    color: #E96259;
  }
}

.rela {
  position: relative;
  z-index: 11;
}

.red_top_bg {
  height: 50px;
  background: #76b900;
  background-size: 100% 100%;
  position: fixed;
  z-index: 15;
}

.warp1 {
  margin-top: 52px;

  .item {
    height: 50px;
    padding: 0 16px;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #ECECEC;

    &:last-child {
      border-bottom: none;
    }

    input {
      line-height: 14px;
      width: calc(100% - 70px);
      text-align: right;
    }
  }
}

.ari_font {
  width: 70px;
  word-break: keep-all;
  white-space: nowrap;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, .8);
  line-height: 20px;
}
.choose_bank{
  width: calc(100% - 70px);
  text-align: right;
  font-size: 14px;
}

.basic_btn {
  margin: 25px auto 0 auto;
}
.demo {
  padding: 20px 16px 0;
  font-size: 14px;
  line-height: 30px;
}
.bank-item {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  font-size: 14px;
}

.bank-logo {
  width: 36px;
  /*height: 24px;*/
  margin-right: 10px;
}

</style>
